import { some, forEach } from 'lodash';
import React from 'react';

import connect from 'components/lib/connect';
import FeatureNotification from './feature_notification';
import FeatureNotificationTypes from 'scripts/domain/models/agent_notification/feature_notification_types';
import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';

const getHolidayReady = {
  feature: FeatureNotificationTypes.IN_APP_NOTIFICATION,
  roleFlags: ['teamManagement'],
  orgIds: [],
  key: 'get-holiday-ready',
  text: 'Get Holiday-Ready',
  subtext:
    'The holiday surge is almost here—join our November 5th classroom to optimize your Gladly setup and avoid last-minute stress.',
  url: 'https://gladly.zoom.us/meeting/register/9Pow92FSSselxkgmLeC-YQ#/registration',
  urlText: 'Register Now',
  endAt: '2025-11-04T06:00:00.000Z',
};

const CURRENT_FEATURES = [getHolidayReady];

export function FeatureNotificationList({ agentPreferences, organization }) {
  const isFeatureEnabled = useIsFeatureEnabled();

  let featureNotifications = [];
  forEach(CURRENT_FEATURES, featureProps => {
    if (shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled, organization)) {
      featureNotifications.push(<FeatureNotification {...featureProps} />);
    }
  });

  if (!featureNotifications.length) {
    return null;
  }

  return <React.Fragment>{featureNotifications}</React.Fragment>;
}

const FeatureNotificationListContainer = connect(mapStateToProps)(FeatureNotificationList);

function mapStateToProps({ getProvider }) {
  const agentPreferences = getProvider('agentPreferences').get();
  const organization = getProvider('auth').get()?.claims;

  return {
    agentPreferences,
    organization,
  };
}

export function useHasFeaturesToShow(agentPreferences, organization) {
  const isFeatureEnabled = useIsFeatureEnabled();
  return some(CURRENT_FEATURES, featureProps => {
    return shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled, organization);
  });
}

function shouldShowNotification(featureProps, agentPreferences, isFeatureEnabled, organization) {
  const roleRestricted = featureProps.roleFlags && featureProps.roleFlags.length;
  const restrictedAndHasRole = some(featureProps.roleFlags, roleFlag => isFeatureEnabled(roleFlag));
  const flagRestricted = featureProps.flag;

  const organizationId = organization?.id || organization?.orgId || '';
  const orgRestricted = !!featureProps.orgIds.length;
  const belongsToOrg = some(featureProps.orgIds, orgId => orgId.toLowerCase() === organizationId.toLowerCase());

  const currentTime = new Date();
  const startRestricted = !!featureProps.startAt;
  const afterStart = startRestricted ? currentTime > new Date(featureProps.startAt) : true;
  const endRestricted = !!featureProps.endAt;
  const beforeEnd = endRestricted ? currentTime < new Date(featureProps.endAt) : true;

  return (
    (!orgRestricted || belongsToOrg) &&
    (!roleRestricted || restrictedAndHasRole) &&
    (!flagRestricted || isFeatureEnabled(featureProps.flag)) &&
    afterStart &&
    beforeEnd &&
    !agentPreferences.hasSeenFeatureNotification(featureProps.feature)
  );
}

export default FeatureNotificationListContainer;
